/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x108b80 from'./compiledmessages.js';export default class MessagesCompressor{static['decode'](_0x995470,_0x45f17f){const _0x14681b=_getType(_0x45f17f)['decode']('undefined'==typeof window?_0x995470:new Uint8Array(_0x995470));return _0x45f17f['fromJSON']({..._0x14681b});}static['encode'](_0x8c1e0e){const _0x4fcf07=_getType(_0x8c1e0e['constructor']),_0x30bff4=_0x8c1e0e['toJSON'](),_0x526c45=_0x4fcf07['verify'](_0x30bff4);if(_0x526c45)throw Error(_0x526c45);return _0x4fcf07['encode'](_0x4fcf07['create'](_0x30bff4))['finish']();}}function _getType(_0x3c8bc8){return _0x108b80[_0x3c8bc8['DESCRIPTOR_NAME']];}